import { AxiosResponse } from "axios";
import { SET_CALL_DISPOSITIONS, SET_CALL_DISPOSITION, SET_ERRORMSG } from "@/store/mutation-types";
import { CLEAR_CALL_DISPOSITION_ISLOADING, GET_CALL_DISPOSITIONS } from "@/store/action-types";
import { StateObject } from "@/dtos/State.dto";
import CallDisposition from "@/services/call-disposition";
import { Module } from "vuex";
import { GetCallDisposition } from "@/dtos/CallDisposition.dto";

const callDisposition: Module<any, {}> = {
  state: {
    callDisposition: {
      data: null,
      isLoading: false,
    },
    callDispositions: {
      data: null,
      isLoading: false,
    },
  },
  getters: {
    callDisposition: (state: { callDisposition: any }) => state.callDisposition,
    callDispositions: (state: { callDispositions: any }) => state.callDispositions,
  },
  mutations: {
    [SET_CALL_DISPOSITION]: (
      state: { callDisposition: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      if (payload.data != null) state.callDisposition.data = payload.data;
      state.callDisposition.isLoading = payload.isLoading;
    },
    [SET_CALL_DISPOSITIONS]: (
      state: { callDispositions: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      if (payload.data != null) state.callDispositions.data = payload.data;
      state.callDispositions.isLoading = payload.isLoading;
    },
  },
  actions: {
    [GET_CALL_DISPOSITIONS]: async ({ commit }: any, payload: any) => {
      commit(SET_CALL_DISPOSITIONS, { data: null, isLoading: true });

      try {
        const result: AxiosResponse = await CallDisposition.getCallDispositions(
          payload as GetCallDisposition
        );

        if (result) {
          if (result.data.status) {
            commit(SET_CALL_DISPOSITIONS, {
              data: result.data.data,
              isLoading: false,
            });
            return true;
          }
          commit(SET_CALL_DISPOSITIONS, { data: null, isLoading: false });
          commit(SET_ERRORMSG, result.data.msg);
          return false;
        } else {
          commit(SET_CALL_DISPOSITIONS, { isLoading: false });
          return false;
        }
      } catch (error: any) {
        commit(SET_CALL_DISPOSITIONS, { data: null, isLoading: false });

        if (error.code === "ECONNABORTED" || error.message?.includes("timeout")) {
          commit(SET_ERRORMSG, "Request timed out. Please check your connection and try again.");
        } else {
          commit(SET_ERRORMSG, error.response?.data?.message || "Failed to load call dispositions");
        }
        return false;
      }
    },
    [CLEAR_CALL_DISPOSITION_ISLOADING]: ({ commit }) => {
      commit(SET_CALL_DISPOSITION, { isLoading: false });
      commit(SET_CALL_DISPOSITIONS, { isLoading: false });
    },
  },
};

export default callDisposition;
